import * as React from 'react'
import { RotatingLines } from 'react-loader-spinner'
import { styled } from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  justify-content: center;
  align-items: center;
  padding-top: 2rem;
  padding-bottom: 2rem;
`

const Small: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <Container>
      {children}
      <RotatingLines strokeColor="var(--primary)" width="100" />
    </Container>
  )
}

const Large: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <Container>
      {children}
      <RotatingLines strokeColor="var(--primary)" width="150" />
    </Container>
  )
}

export default Object.assign(Large, {
  Small
})
